import React from 'react';
import { Link } from 'react-router-dom';
import tubulins from '../images/intro-tubulin.png';
import npc from '../images/intro-npc.png';
import SingleDataset from '../datasetsPage/SingleDataset';

class ChallengeRealData extends React.Component {
    constructor(props){
        super(props)
        this.state = {dataList:[]}
        this.fetchData = this.fetchData.bind(this)
    }
    componentDidMount(){
        this.fetchData('real/challenge')
    }
    // fetch the list of jsons from server
    fetchData(name){
        const data = new FormData();
        data.append('name',name);
        fetch('/api/getDatasets',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
                response.json().then(dataList => {
                    
                    this.setState({dataList:dataList})
                })
            }
        })
    }
    
    render() {
        return (
        <div>
            <h1>Real Experiments, 3D Astigmatism</h1>
            <div style={{display:"flex"}}>
                <div style={{maxWidth:"600px"}}>
                    The experimental datasets consist of sequences of frames from real stained biologicial samples. A Z-stack of beads is provided for the axial calibration.
                    <div>The experimental results are available <Link to={"/Challenge/ChallengeRealDataResults"}>here</Link></div>
                </div>
                <div>
                    <img src={tubulins}  alt="banner" style={{"float":"right","paddingLeft":"10px", "width":"300px"}}/>
                </div>
                <div>
                    <img src={npc}  alt="banner" style={{"float":"right","paddingLeft":"10px", "width":"300px"}}/>
                </div> 
            </div>
            <p style={{"padding":"20px","clear":"both"}}></p>
            {this.state["dataList"].map(d => {
                return <SingleDataset data={d} rootDir={"./../datasets/real/challenge"} history={this.props.history}/>
            })}
        </div>
      );
    }
}

export default ChallengeRealData;